import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        padding: 20,
        width: 300
    },
    flexBox: {
        display: 'flex', 
        justifyContent: 'center'
    },
    wrap: {
        display: 'flex', 
        width: '100%', 
        justifyContent: 'space-between'
    },
    send: {
        background: 'gold', 
        width: '100%', 
        display: 'flex', 
        justifyContent: 'center', 
        borderRadius: 4, 
        padding: '10px 0'
    },
    text: {
        width: 'calc(100% - 8px)',
        resize: 'none'
    }
}))

export {
    useStyles
}